export default [
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<p>Перекидной календарь А2 (420х594мм) на пружине с индивидуальным рисунком на каждом развороте</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `<p>Цифровая печать</p>`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
